import { UPDATE_TOKEN_ACTION } from './modules/actionTypes';

export const udpateTokenAction = (token: string) => ({
  type: UPDATE_TOKEN_ACTION,
  payload: token,
});

export type TokenActionTypes = ReturnType<typeof udpateTokenAction>;
